import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class EntidadService {

  constructor(private http: HttpClient, private _apiService:ApiService) { }

  private path: string = '/entidad';
  private url: string = this._apiService.server+this.path;

  /**
   * Devuelve una lista de entidades.
   * @returns
   */
   getListEntidad(): Observable<any> {
    return this._apiService.get(this.url);
  }
}
